import React from "react";

import {
  CONDITION_TYPES,
  CONDITION_OPERATORS
} from "../constants/enums";

export default function ConditionEditor({
  conditions = [],
  onChange
}) {

  const addCondition = () => {

    onChange([
      ...conditions,
      {
        type: CONDITION_TYPES[0],
        operator: CONDITION_OPERATORS[0],
        value: ""
      }
    ]);

  };

  const updateCondition = (
    index,
    field,
    value
  ) => {

    const updated = [...conditions];

    updated[index] = {
      ...updated[index],
      [field]: value
    };

    onChange(updated);

  };

  const removeCondition = (index) => {

    onChange(
      conditions.filter(
        (_, i) => i !== index
      )
    );

  };

  return (

        <div className="form-section">

        <h3 className="section-title">
        Conditions
        </h3>

      {

        conditions.map(
          (condition, index) => (

            <div
              key={index}
              className="condition-row card-row"
            >

              <select
                className="form-input"
                value={
                  condition.type ||
                  CONDITION_TYPES[0]
                }
                onChange={(e) =>
                  updateCondition(
                    index,
                    "type",
                    e.target.value
                  )
                }
              >

                {

                  CONDITION_TYPES.map(type => (

                    <option
                      key={type}
                      value={type}
                    >
                      {type}
                    </option>

                  ))

                }

              </select>

              <select
                className="form-input"
                value={
                  condition.operator ||
                  CONDITION_OPERATORS[0]
                }
                onChange={(e) =>
                  updateCondition(
                    index,
                    "operator",
                    e.target.value
                  )
                }
              >

                {

                  CONDITION_OPERATORS.map(op => (

                    <option
                      key={op}
                      value={op}
                    >
                      {op}
                    </option>

                  ))

                }

              </select>

              <input
                className="form-input"
                placeholder="Value"
                value={condition.value || ""}
                onChange={(e) =>
                  updateCondition(
                    index,
                    "value",
                    e.target.value
                  )
                }
              />

              <button
                type="button"
                className="btn btn-danger"
                onClick={() =>
                  removeCondition(index)
                }
              >
                Remove
              </button>

            </div>

          )

        )

      }

        <div className="section-actions">

        <button
            type="button"
            className="btn btn-secondary"
            onClick={addCondition}
        >
            Add Condition
        </button>

        </div>

    </div>

  );

}